import { Auth } from "aws-amplify";

export async function apiKeyManagementHeaders() {
  const session = await Auth.currentSession();
  return {
    "X-Api-Key": session.getAccessToken().getJwtToken(),
  };
}
